import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { TaxonomyPicker } from "@/components/TaxonomyPicker";
import { Tags } from "lucide-react";

export const TaxonomyCard = () => {
  const { user, refresh } = useAuth();
  const own = user.role;
  const otherArea = own === "artist" ? "supplier" : "artist";
  const [tax, setTax] = useState(user.taxonomy || {});
  const [other, setOther] = useState(user.taxonomyOther || {});
  const [hybrid, setHybrid] = useState(!!(user.taxonomy || {})[otherArea]);
  const save = async () => {
    const payload = { ...tax };
    if (!hybrid) delete payload[otherArea];
    try { await api.patch("/me", { taxonomy: payload, taxonomyOther: other }); toast.success("Categorie aggiornate"); refresh(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Errore nel salvataggio"); }
  };
  return (
    <div className="mt-8 card-premium p-6" data-testid="taxonomy-card">
      <div className="flex items-center gap-2 mb-1"><Tags className="w-5 h-5 text-gold"/><h3 className="font-display text-xl font-bold">Le tue categorie</h3></div>
      <p className="text-sm text-slate-600 mb-4">I committenti ti trovano quando cercano almeno una delle sottocategorie che spunti qui.</p>
      <label className="flex items-center gap-2 text-sm mb-4 cursor-pointer">
        <input type="checkbox" data-testid="tax-hybrid" checked={hybrid} onChange={(e) => setHybrid(e.target.checked)} className="accent-[#D5A34C]"/>
        {own === "artist" ? "Offro anche servizi come Fornitore" : "Mi esibisco anche come Artista / Performer"}
      </label>
      <TaxonomyPicker testPrefix="dash-tax" areas={hybrid ? [own, otherArea] : [own]} value={tax} other={other} onChange={(v, o) => { setTax(v); setOther(o); }}/>
      <div className="flex justify-end mt-4"><button data-testid="tax-save" onClick={save} className="btn-pill-gold text-sm">Salva categorie</button></div>
    </div>
  );
};
